import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { toast } from "sonner";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

const load = (k, def) => {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : def; } catch { return def; }
};

export function AppProvider({ children }) {
  const [saved, setSaved] = useState(() => load("pbs_saved", []));
  const [compare, setCompare] = useState(() => load("pbs_compare", []));
  const [recentSearches, setRecentSearches] = useState(() => load("pbs_recent", []));
  const [leadModal, setLeadModal] = useState({ open: false, property: null, type: "enquiry", title: "" });

  useEffect(() => { localStorage.setItem("pbs_saved", JSON.stringify(saved)); }, [saved]);
  useEffect(() => { localStorage.setItem("pbs_compare", JSON.stringify(compare)); }, [compare]);
  useEffect(() => { localStorage.setItem("pbs_recent", JSON.stringify(recentSearches)); }, [recentSearches]);

  const toggleSaved = useCallback((prop) => {
    setSaved((prev) => {
      const exists = prev.find((p) => p.slug === prop.slug);
      if (exists) { toast("Removed from saved"); return prev.filter((p) => p.slug !== prop.slug); }
      toast.success("Saved to your shortlist"); return [...prev, prop];
    });
  }, []);

  const isSaved = useCallback((slug) => saved.some((p) => p.slug === slug), [saved]);

  const toggleCompare = useCallback((prop) => {
    setCompare((prev) => {
      const exists = prev.find((p) => p.slug === prop.slug);
      if (exists) return prev.filter((p) => p.slug !== prop.slug);
      if (prev.length >= 4) { toast.error("You can compare up to 4 properties"); return prev; }
      toast.success("Added to compare");
      return [...prev, prop];
    });
  }, []);

  const inCompare = useCallback((slug) => compare.some((p) => p.slug === slug), [compare]);
  const clearCompare = useCallback(() => setCompare([]), []);

  const addRecentSearch = useCallback((text) => {
    if (!text) return;
    setRecentSearches((prev) => [text, ...prev.filter((t) => t !== text)].slice(0, 6));
  }, []);

  const openLead = useCallback((opts = {}) => {
    setLeadModal({ open: true, property: opts.property || null, type: opts.type || "enquiry", title: opts.title || "" });
  }, []);
  const closeLead = useCallback(() => setLeadModal((m) => ({ ...m, open: false })), []);

  return (
    <AppContext.Provider value={{
      saved, toggleSaved, isSaved,
      compare, toggleCompare, inCompare, clearCompare,
      recentSearches, addRecentSearch,
      leadModal, openLead, closeLead,
    }}>
      {children}
    </AppContext.Provider>
  );
}
